import { PaymentStatus } from '@common/credits/ProfessionalEdition/types';
import { AlertTriangleIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Stack } from '@prophecy/ui-v3';
import { Dialog } from '@prophecy/ui-v3/Dialog';
import { DialogSize } from '@prophecy/ui-v3/Dialog/types';
import { Text } from '@prophecy/ui-v3/Typography';
import styled from 'styled-components';

export const PaymentStatusDialog = ({
  paymentStatus,
  onClose
}: {
  paymentStatus: PaymentStatus;
  onClose: () => void;
}) => {
  const title =
    paymentStatus === PaymentStatus.Paid ? (
      <Text level='xl' tone={theme.colors.success600} weight={theme.fontWeight.semiBold}>
        You're Pro now 🎉
      </Text>
    ) : (
      <Stack direction='horizontal' gap={theme.spaces.x6} alignY='center'>
        <AlertTriangleIcon size={'m'} color={theme.colors.error500} type={'default'} />
        <Text level='xl' tone={theme.colors.error500}>
          Payment Failed
        </Text>
      </Stack>
    );
  return (
    <Dialog
      open={true}
      size={DialogSize.l}
      data-test-id='payment-status-dialog'
      title={title}
      onClose={onClose}
      okButton={{ children: paymentStatus === PaymentStatus.Paid ? 'Start building now' : 'Try Again' }}
      onOk={onClose}
      closeButton={null}
      closable={false}>
      <StyledStack direction='vertical' gap={theme.spaces.x12} align='center' padding={`${theme.spaces.x12} 0`}>
        {paymentStatus === PaymentStatus.Paid ? (
          <>
            <Text level='md' tone={theme.colors.gray600}>
              Unlimited users. Advanced transformations. More credits to run AI and scale your data pipelines.
            </Text>
            <Text level='md' tone={theme.colors.gray600}>
              Ready to make the most of your upgrade?
            </Text>
          </>
        ) : (
          <Text level='md' tone={theme.colors.gray600}>
            There was an error processing your payment. Please try again!
          </Text>
        )}
      </StyledStack>
    </Dialog>
  );
};

const StyledStack = styled(Stack)`
  margin-top: ${theme.spaces.x12};
`;
